var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.902,
    height: 20,
    viewBox: "0 0 19.902 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M15.6,16.8a8.618,8.618,0,0,0-11.1,0A8.618,8.618,0,0,0,15.6,16.8Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M16.5,16A8.708,8.708,0,0,0,3.6,4.3,8.589,8.589,0,0,0,3.6,16,9.867,9.867,0,0,1,16.5,16Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M10,.1a10.029,10.029,0,0,0-10,10,9.711,9.711,0,0,0,2.6,6.7l.9.9a9.867,9.867,0,0,0,12.9,0l.9-.9a9.711,9.711,0,0,0,2.6-6.7A9.881,9.881,0,0,0,10,.1Zm0,18.7a8.459,8.459,0,0,1-5.5-2,8.618,8.618,0,0,1,11.1,0A8.929,8.929,0,0,1,10,18.8ZM16.5,16A9.867,9.867,0,0,0,3.6,16,8.708,8.708,0,1,1,16.5,4.3a8.515,8.515,0,0,1,2.3,5.8A9.62,9.62,0,0,1,16.5,16Z",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M10,5.8a2.946,2.946,0,0,0-3,3,3.1,3.1,0,0,0,6.2,0,3.119,3.119,0,0,0-3.2-3Zm0,4.8a1.8,1.8,0,1,1,1.8-1.8h0A1.793,1.793,0,0,1,10,10.6Z",
    fill: "#3bb0ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6e64998bdbc40cbcde479d70a50e2dfa.svg";
export { ForwardRef as ReactComponent };